import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {brandTableReady,rowsPerPageState,searchTextState,paginationState,brandIdForAction,previousFilterStatus,previousFilterGroupId} from '../redux/brands'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/brandTable.css'


import {BrandGroups} from './DropDowns/index'

import {EntityStatus} from '../../../common/DropDowns/index'


import * as Helpers from '../../../common/helpers'


function filterUnwantedData(brandsData) {
    let array = []
    if (brandsData && brandsData.data && brandsData.data.list) {
        array = brandsData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.brand_name = lineData.name ? lineData.name : "NA"
            newLineData.code = lineData.code ? lineData.code : "NA"
            newLineData.brand_group_name = lineData.brand_group && lineData.brand_group.name ? lineData.brand_group.name : "NA"
            newLineData.status =lineData.status ? lineData.status : "NA"

             newLineData.brand_platforms=""
             let temp = [];
                if(lineData.brand_platforms.length>0){                    
                    for (var k = 0; k < lineData.brand_platforms.length; k++) {                        
                        temp[k]=lineData.brand_platforms && lineData.brand_platforms[k].platform && lineData.brand_platforms[k].platform.name ? lineData.brand_platforms[k].platform.name: ""
                        
                    }
                }

                newLineData.brand_platforms=temp.join(", ");



            newArray[i] = newLineData
        }
    }
    return newArray
}


class BrandsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            brandData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_group_id:"",
            filter_status:"ACTIVE",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(brandTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.BRANDS_TABLE))
        this.props.dispatch(subHeaderDataUpdate())


        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

            let previousFilterStatus=""
            let previousFilterGroupId=""

         if (this.props.brands && this.props.brands.previousFilterStatus && this.props.brands.previousFilterStatus!==undefined) {
            previousFilterStatus=this.props.brands.previousFilterStatus
         }         

         if (this.props.brands && this.props.brands.previousFilterGroupId && this.props.brands.previousFilterGroupId!==undefined) {
            previousFilterGroupId=this.props.brands.previousFilterGroupId
         }

         if(previousFilterStatus===undefined || previousFilterStatus===null || previousFilterStatus===""){
            previousFilterStatus="ACTIVE"
         }
         
         this.setState({
              filter_status:previousFilterStatus,
              filter_group_id:previousFilterGroupId
         },() => {
            this.getBrandsData();
        });

        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getBrandsData = () => {
        apiService.getBrandsData(this.state.filter_status,this.state.filter_group_id)
            .then(brandsData => {
                if (brandsData && this.isComponentMounted) {
                    this.validateBuildNumber(brandsData)
                    if (brandsData.status === "SUCCESS") {
                        let array = filterUnwantedData(brandsData), pageNo = 1
                        if (this.props.brands && this.props.brands.previousPaginationValue) {
                            pageNo = this.props.brands.previousPaginationValue
                        }
                        this.setState({
                            brandData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: brandsData.reason ? brandsData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(brandTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(brandTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

     entityStatusChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterStatus(""))
             this.setState({
                filter_status :"",            
            })
        }else{
            this.props.dispatch(previousFilterStatus(data.value))
            this.setState({
                filter_status :data.value,            
            })
        }
    }

    brandGroupChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterGroupId(""))
             this.setState({
                filter_group_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterGroupId(data.value))
            this.setState({
                filter_group_id :data.value,            
            })
        }
    }


    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.brands && this.props.brands.previousRowsPerPageValue) {
            value = this.props.brands.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/brands/addEdit",this.props.user)){
                    return(
                        <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                            <button className="btn btn-primary button-custom"
                                    style={{ marginLeft: "5px" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.props.dispatch(brandIdForAction())
                                        this.props.history.push("/dashboard/brands/addEdit")
                                    }}>
                                    Add
                                </button>
                         </div>

                        )
                      }
                   })()}
                   
                   

                     <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <BrandGroups brandGroupChange={this.brandGroupChange} selectedValue={this.state.filter_group_id} />
                    </div>
                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <EntityStatus type="BRANDS" entityStatusChange={this.entityStatusChange} selectedValue={this.state.filter_status} /> 
                    </div>
                    </div>

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredBrandList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.brandData.length>=(this.props.brands.previousPaginationValue*this.props.brands.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.brands.previousPaginationValue*this.props.brands.previousRowsPerPageValue)-this.props.brands.previousRowsPerPageValue+1} to {this.props.brands.previousPaginationValue*this.props.brands.previousRowsPerPageValue} of {this.state.brandData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.brands.previousPaginationValue*this.props.brands.previousRowsPerPageValue)-this.props.brands.previousRowsPerPageValue+1} to {this.state.brandData.length} of {this.state.brandData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredBrandList = () => {
       
        this.props.dispatch(brandTableReady(false))
        this.resetSearchAndPagination()
        this.getBrandsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getBrandsData()
        this.props.dispatch(brandTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }


    resetFilterValues = () => {
        this.props.dispatch(brandTableReady(false))
        this.setState({
            filter_status:"",
            filter_group_id:"",
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterStatus(""))
            this.props.dispatch(previousFilterGroupId(""))

            this.getBrandsData()
        });

        
    }

    actionButtonsCreator = (cell, row) => {
        let editButton =""


        if(Helpers.checkPrivileges("/dashboard/brands/addEdit",this.props.user)){
        
            editButton=<button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editBrand(row)
                }}>
                Edit
            </button>
        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.brands && this.props.brands.previousPaginationValue
            && this.props.brands.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editBrand = (row) => {
        if (row && row.id) {
            this.props.dispatch(brandIdForAction(row.id))
            this.props.history.push("/dashboard/brands/addEdit")
        } else {
            this.dialog.show({
                title: "Brand Identification number not found",
                body: 'Brand id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.brands && this.props.brands.previousRowsPerPageValue) {
            sizeperPage = this.props.brands.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="brands-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.brandData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                        
                    <TableHeaderColumn
                        dataField="brand_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="code"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Code
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="brand_group_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Group
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="brand_platforms"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Platforms
                    </TableHeaderColumn>


                    
                    <TableHeaderColumn
                        dataField="status"
                        //width="90"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>
                    
                    
                     <TableHeaderColumn
                        //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        brands: state.brands
    }
}

export default connect(mapStateToProps)(withRouter(BrandsTable))


// WEBPACK FOOTER //
// ./src/modules/Brands/Components/BrandsTable.js